import {
  DevHubBox,
  DevHubButton,
  DevHubCircularProgress,
  DevHubGrid,
} from '@devxdiscover/devhub-ui';
import { useContext } from 'react';
import { Feedback } from '../feedbackTypes';
import { CSVLink } from 'react-csv';
import { SystemContext } from '../../../../contexts/SystemContext';

interface Props {
  feedback: Feedback[];
}

/**
 * ExportFeedback component.
 * @param props - The component props.
 */
const ExportFeedback = (props: Props) => {
  const { app } = useContext(SystemContext);

  const formatDataForCSV = () => {
    if (props.feedback.length === 0) return 'No feedback available';

    return props.feedback.map((feedback: Feedback) => {
      return {
        'Created Date': new Date(feedback?.timestamp).toLocaleString('en-US'),
        URL: feedback.url,
        Rating: feedback.rating,
        Comment: feedback.message,
      };
    });
  };

  return (
    <div>
      <DevHubGrid>
        <DevHubBox
          display="flex"
          justifyContent="flex-end"
          width="100%"
          margin="1rem"
          marginBottom="1rem"
        >
          {props?.feedback ? (
            <CSVLink
              filename={`${app?.name?.replace(/\s/g, '_')}_feedback`}
              data={formatDataForCSV()}
              target="_blank"
            >
              <DevHubButton variant="contained" color="primary" height="medium">
                Export Feedback
              </DevHubButton>
            </CSVLink>
          ) : (
            <DevHubCircularProgress />
          )}
        </DevHubBox>
      </DevHubGrid>
    </div>
  );
};

export default ExportFeedback;
